export default __webpack_public_path__ + "locales/sq-AL/JavascriptSdk.json?hash=180c408436ba71d0e45ce5742bda37dd";